import Logger from './logger';

const noop = () => {};

export default class EventDispatcher {
  _listenersMap = new Map();
  _onError = noop;

  setErrorHandler(onError) {
    this._onError = onError || noop;
  }

  getRegisteredEvent(eventName) {
    if (!eventName) {
      throw new Error('"eventName" is required');
    }
    return this._listenersMap.get(eventName) || [];
  }

  addEventListener(eventName, callback) {
    const listeners = this.getRegisteredEvent(eventName);
    listeners.push(callback);
    this._listenersMap.set(eventName, listeners);
  }

  removeEventListener(eventName, callback) {
    const listeners = this.getRegisteredEvent(eventName).filter(listener => listener !== callback);
    if (listeners.length) {
      this._listenersMap.set(eventName, listeners);
    } else {
      this._listenersMap.delete(eventName);
    }
  }

  dispatchEvent(eventName, params = {}, skipWrapping = false) {
    let eventData;

    if (skipWrapping) {
      eventData = params;
    } else {
      params.eventName = eventName;
      eventData = { detail: params };
    }

    for (const callback of this.getRegisteredEvent(eventName)) {
      try {
        Promise.resolve(callback(eventData)).catch((e) => {
          Logger.error(`Async event handler for event "${eventName}" failed`, e);
          this._onError(e);
        });
      } catch (e) {
        Logger.error(`Event handler for event "${eventName}" failed`, e);
        this._onError(e);
      }
    }
  }

  destroyEventDispatcher() {
    this._listenersMap.clear();
  }
}
